var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContract({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2722_11463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1732 2.73291C12.1732 2.35754 12.0267 2.00416 11.7612 1.73866L10.4355 0.412977C10.1737 0.151133 9.802 0.000976562 9.43213 0.000976562H9.35156V2.81348H12.1732L12.1732 2.73291Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56053 9.67401C8.65025 9.40163 8.80681 9.14804 9.01097 8.94251L12.1848 5.78148V3.75098H8.89103C8.63194 3.75098 8.4375 3.54132 8.4375 3.28223V0.000976562H1.40625C0.630813 0.000976562 0 0.631789 0 1.40723V14.5947C0 15.3702 0.630813 16.001 1.40625 16.001H10.766C11.5415 16.001 12.1848 15.3702 12.1848 14.5947V11.0963L11.6697 11.5989C11.4609 11.8058 11.2165 11.9564 10.9409 12.0484L9.45044 12.546L9.22338 12.5584C8.848 12.5584 8.49278 12.3757 8.27216 12.0699C8.05334 11.7655 7.99384 11.3709 8.11284 11.0144L8.56053 9.67401ZM2.34375 8.43848H7.01603C7.27513 8.43848 7.48478 8.64813 7.48478 8.90723C7.48478 9.16632 7.27513 9.37598 7.01603 9.37598H2.34375C2.08466 9.37598 1.875 9.16632 1.875 8.90723C1.875 8.64813 2.08466 8.43848 2.34375 8.43848ZM1.875 7.03223C1.875 6.77313 2.08466 6.56348 2.34375 6.56348H7.01603C7.27513 6.56348 7.48478 6.77313 7.48478 7.03223C7.48478 7.29132 7.27513 7.50098 7.01603 7.50098H2.34375C2.08466 7.50098 1.875 7.29132 1.875 7.03223ZM1.875 10.7822C1.875 10.5231 2.08466 10.3135 2.34375 10.3135H7.01603C7.27513 10.3135 7.48478 10.5231 7.48478 10.7822C7.48478 11.0413 7.27513 11.251 7.01603 11.251H2.34375C2.08466 11.251 1.875 11.0413 1.875 10.7822ZM8.89103 13.126C9.15013 13.126 9.35978 13.3356 9.35978 13.5947C9.35978 13.8538 9.15016 14.0635 8.89103 14.0635H6.07853C5.81944 14.0635 5.60978 13.8538 5.60978 13.5947C5.60978 13.3356 5.81944 13.126 6.07853 13.126H8.89103ZM2.34375 5.62598C2.08466 5.62598 1.875 5.41632 1.875 5.15723C1.875 4.89813 2.08466 4.68848 2.34375 4.68848H8.89103C9.15013 4.68848 9.35978 4.89813 9.35978 5.15723C9.35978 5.41632 9.15013 5.62598 8.89103 5.62598H2.34375Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40854 10.0889L9.00073 11.3123C8.9396 11.4956 9.11401 11.67 9.29729 11.6087L10.52 11.2004L9.40854 10.0889Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.05 6.22949L9.96289 9.31665L11.2943 10.6481C11.992 9.95018 13.3497 8.59234 14.3813 7.56074L13.05 6.22949Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7243 4.88498C15.5595 4.71926 15.3169 4.62451 15.0596 4.62451C14.8024 4.62451 14.5598 4.71926 14.394 4.88545L13.7129 5.56661L15.0441 6.89779C15.417 6.52486 15.6747 6.26711 15.7253 6.21657C16.0915 5.84986 16.0914 5.25254 15.7243 4.88498Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7246 6.21613L15.7247 6.21607C15.7259 6.21488 15.7264 6.21435 15.7274 6.21338C15.7264 6.21438 15.7259 6.21491 15.7246 6.21613Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7266 6.21363C15.7281 6.21213 15.7298 6.21038 15.7307 6.20947C15.7298 6.21041 15.7281 6.21213 15.7266 6.21363Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7324 6.20933C15.7355 6.2063 15.7355 6.20623 15.7324 6.20933V6.20933Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2722_11463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.ccd28b8cc2043e13ece2d248af33c065.svg";
export { ForwardRef as ReactComponent };